import {
  FacebookOutlined,
  TwitterOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { CITY_LINKS, NATIONAL_LINK } from "../../data/locations";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">

      <div className="footer-top">
        <div className="footer-container">

          {/* Brand */}
          <div className="footer-brand">
            <span className="footer-brand-name">GARVAANA</span>
            <span className="footer-brand-tagline">Enterprise</span>

            <p>
              Indias's premier landscape design and garden management company.
              We create extraordinary outdoor spaces with creativity, precision,
              and an unwavering love of nature.
            </p>

            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noreferrer">
                <FacebookOutlined />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer">
                <TwitterOutlined />
              </a>
              <a href="https://www.instagram.com/garvaana.landscape" target="_blank" rel="noreferrer">
                <InstagramOutlined />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer">
                <LinkedinOutlined />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h3>Contact</h3>

            {/* LOCATION → GOOGLE MAP */}
            <p>
              <EnvironmentOutlined className="icon" />
              <a
                href="https://maps.app.goo.gl/Q1n2ZzazmT9F1xRV9"
                target="_blank"
                rel="noreferrer"
              >
                Gajraula, Uttar Pradesh
              </a>
            </p>

            {/* CALL */}
            <p>
              <PhoneOutlined className="icon" />
              <a href="tel:+919800040505">
                +91-9800040505
              </a>
            </p>

            {/* EMAIL → GMAIL */}
            <p>
              <MailOutlined className="icon" />
              <a href="mailto:contact@garvana.com">
                contact@garvana.com
              </a>
            </p>
          </div>

          {/* Service Areas — core cities + link to the full hub page */}
          <div className="footer-section">
            <h3>Service Areas — Delhi NCR</h3>
            <ul className="footer-areas footer-quicklinks">
              {CITY_LINKS.map((c) => (
                <li key={c.city}>
                  <Link to={`/${c.slug}`}>Landscape &amp; Garden Services in {c.city}</Link>
                </li>
              ))}
            </ul>
            <Link to="/service-areas" className="footer-areas__national">
              ✦ View all service areas →
            </Link>
            <Link to={`/${NATIONAL_LINK.slug}`} className="footer-areas__national">
              ✦ Pan-India Landscape Services
            </Link>
          </div>

          {/* Quick links */}
          <div className="footer-section">
            <h3>Explore</h3>
            <ul className="footer-areas footer-quicklinks">
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/products">Our Plants</Link></li>
              <li><Link to="/service-areas">Service Areas</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom-wrapper">
        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Garvaana Enterprise</p>

          <div className="footer-bottom-links">
            <a href="/privacy-policy">Privacy</a>
            <a href="/terms">Terms</a>
          </div>
        </div>
      </div>

    </footer>
  );
}